import { createContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  /** What the user picked. */
  preference: ThemePreference;
  /** What is actually painted right now. */
  theme: ResolvedTheme;
  setPreference: (next: ThemePreference) => void;
  /** Light ⇄ dark, leaving `system` behind. */
  toggle: () => void;
}

/** Lives in its own module so `ThemeProvider.tsx` only exports a component. */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
